export default __webpack_public_path__ + "static/media/Logo2023.cb39b2dd.png";